import React, {useState, useEffect} from "react";
import {ListAcademyService} from "../services/GeneralServices";

export const AcademyContext = React.createContext({});

export default function AcademyProvider({children}) {
   const [isLoading, setLoding] = useState({list: true});
   const [academyList, setAcademy] = useState([]);

   const getList = (force = false) => { 
      if (academyList.length > 0 && !force) return false;
      ListAcademyService()  
         .then(res => res.json())
         .then(resp => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            // console.log(data);
            setAcademy(data);
         })
         .then(() => setLoding(false))
         .catch(e => {
            console.log(e);
         });
   };

   const selectOne = async id => {
      return new Promise(resolve => {
         let filtered = academyList.find(item => item.idDomecqAcademyContent === id);
         resolve(filtered);
      });
   };

   const updateOne = nData => {
      let neData = academyList.map(item => {
         if (item.idDomecqAcademy === nData.idDomecqAcademy) {
            return {...item, ...nData};
         }
         return {...item};
      });
      setAcademy(neData)
   };

   return <AcademyContext.Provider value={{getList, academyList, isLoading, selectOne, updateOne}}>{children}</AcademyContext.Provider>;
}
